import { ROLES } from '../utils/constants';

/** Roles that can open Event System tabs (Flows, Actions, Paging, Triggers, Call Routing). */
export const EVENT_SYSTEM_TAB_ROLES = [ROLES.ADMIN, ROLES.SUPERADMIN, ROLES.TENANT_ADMIN];
